import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuth } from '../auth-context/auth.context';
import { useHistory } from 'react-router-dom';
import SweetAlert from 'react-bootstrap-sweetalert';

export const ProtectedRoute = ({ ...rest }) => {
  const history = useHistory();
  let { user } = useAuth();
  if (!user) {
    return <Redirect to='/auth/sign-in' />;
  }

  return <Route {...rest} />;
};
